import React from 'react';
import jobRepo from '../requests/jobs';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-select/dist/react-select.css';
import {DefaultHeaders} from '../conf/headers';
import {dataFormatter} from '../utils';
import DataGrid from './DataGrid';
import Select from 'react-select'
import Loading from './Loading'
import SearchByMedia from './SearchByMedia'
import moment from 'moment'
import uniqWith from 'lodash/uniqWith'
import differenceBy from 'lodash/differenceBy'
import isEqual from 'lodash/isEqual'
import _get from 'lodash/get'
import { Badge } from 'reactstrap'

const settings = DefaultHeaders()

export default class JobDashboard extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      rows: [],
      selectedRows: [],
      filters: {},
      expanded: {},
      sortColumn: null,
      sortDirection: null,
      loading: false,
      isFetchingMore: false,
      forceStop: false,
      limit: 500,
      metadata: {
        lastKey: null,
        prevKeyUsed: null,
        isLastChunk: false,
        lastChunkSize: -1,
        lastChunkLoaded: []
      }
    }
    this.env = 'prod'
    this.time = moment().format('YYYY-MM-DD')
    this.headers = []
    this.searchJobsByMedia = this.searchJobsByMedia.bind(this)
    // this.handleChange = this.handleChange.bind(this)
  }
  componentWillMount () {
    this.setHeaders()
    this.loadJobs()
    this.setPollInterval()
  }
  setPollInterval() {
    this.interval = setInterval(()=>{
      this.fetchMoreJobs({isCheck: true})
    }, 60000)
  }
  async sleep() {
    let callbackInstance = null
    await new Promise((resolve)=>{
      callbackInstance = setTimeout(()=>{
        resolve(true)
      }, 2000)
    })
    clearTimeout(callbackInstance)
    return
  }
  async fetchMoreJobs ({isCheck = false}) {
    try {
      if (this.state.isFetchingMore && isCheck) {
        console.log('BUSY CALL IN A WILE')
        return
      }
      this.setState({isFetchingMore: true})
      const {limit} = this.state
      let globalMeta = this.state.metadata
      let dataToApped = []
      do {
        if (this.state.forceStop) {
          return
        }
        // console.log('IN - LOOP')
        // console.log('CHECK-TIEM', isCheck)
        // console.log(`globalMeta`, globalMeta)
        let lastKeyToSend = (isCheck && _get(globalMeta, 'isLastChunk', false)) ? _get(globalMeta, 'prevKeyUsed', null) : _get(globalMeta, 'lastKey', null)
        // console.log('LAST KEY TO SEND', lastKeyToSend)
        dataToApped = await jobRepo.getJobs(this.env, this.time, limit, lastKeyToSend)
        // Validating data form endpoint
        if (dataToApped && dataToApped.hasError) {
          console.log('Error Getting Jobs | Details: ', dataToApped.message)
          break
        }
        // console.log(`dataToApped`, dataToApped)
        const {metadata, jobs} = dataToApped
        // console.log(`globalMeta`, globalMeta)
        globalMeta = metadata
        // console.log(`this.state.lastChunkLoaded`, this.state.lastChunkLoaded)
        // console.log(`NEW JOBS`, jobs)
        const newJobsToAppend = differenceBy(jobs, this.state.metadata.lastChunkLoaded, 'job_id')
        // console.log(`newJobsToAppend`, newJobsToAppend)
        const formatedRows = [...this.state.rows, ...dataFormatter(newJobsToAppend)]
        this.setState({ rows: formatedRows,loading: false, metadata})
        await this.sleep()
      } while (!_get(globalMeta, 'isLastChunk', false))
      // console.log('OUT - LOOP')
      this.setState({isFetchingMore: false})
      return
    } catch (error) {
      console.error('fetchMoreJobs', error.message)
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  setHeaders() {
    this.headers = settings.headers
  }

  loadJobs(showLoading = true) {
    if(showLoading){
      this.setState({loading: true})
    }
    console.log('this.interval->', this.interval)
    if (!this.interval) {
      console.log('this.interval->', 'CREATING')
      this.setPollInterval()
    }
    this.setState({
      rows:[],
      forceStop: false,
      metadata: {
      lastKey: null,
      prevKeyUsed: null,
      isLastChunk: false,
      lastChunkSize: -1,
      lastChunkLoaded: []
     }}, () => {
      this.fetchMoreJobs({isCheck: false})
     })
  }

  searchJobsByMedia(mediaId) {
    clearInterval(this.interval)
    this.interval = false
    this.setState({rows: [], loading: true, forceStop: true}, () => {
      jobRepo.getJobsByMediaId(this.env, mediaId)
        .then(jsonR => {
          const { jobs } = jsonR
          let formatedRows = dataFormatter(jobs)
          this.setState({rows: formatedRows, loading: false})
        })
        .catch((error)=>{
          console.log(`Error searchJobsByMedia: ${error.message}`)
        })
    })
  }

  setEnvToQuery = (value) => {
    if(value && value.value !== this.env){
      this.env = value.value
      this.loadJobs()
    }
  }

  setTimeToQuery = (value) => {
    if(value){
      this.time = value.value
      this.loadJobs()
    }
  }

  setNewLimit = (value) => {
    if(value && value.value !== this.state.limit){
      this.setState({limit: value.value}, () => {
        this.loadJobs()
      })
    }
  }

  render() {
    const {loading, rows,  isFetchingMore, limit} = this.state
     const fetchMoreMsg = (isFetchingMore) ?  'Fetching more data...' : 'Data Updated'
    let days = -1 // -1 for UTC 00
    const time_opt = []
    while( days < 7){
      let dateTime = (days === -1) ? moment().add(1, 'days') :  moment().subtract(days, 'days')
      time_opt.push(
        { value: dateTime.format('YYYY-MM-DD'), label: (days===0) ? 'Today' : (days===-1) ? 'Tomorrow' : dateTime.format('D MMM') },
      )
      days++
    }
    // const limitOptions = [
    //   { value: 50, label: '50'},
    //   { value: 100, label: '100'},
    //   { value: 200, label: '200'},
    //   { value: 500, label: '500'}
    // ]
    if(loading) {
      return (<Loading/>)
    }
    return (
        <div id='JobDataGrid'>
          <div className='row mt5 mb5'>
            <div className='col-sm-5'>
              <SearchByMedia parenthandleSubmit={this.searchJobsByMedia} />
            </div>
            <div className='col-sm-7'>
              <div className='pull-right'>
                <label className='titleHead ml5 mr5'> Status: </label>
                <Badge className="ml5 mds-btn-background">
                  {fetchMoreMsg}
                </Badge>
                <label className='titleHead ml5'> Load By Date: </label>
                <Select
                      name="time"
                      value={this.time}
                      options={time_opt}
                      onChange={this.setTimeToQuery}
                      removeSelected={false}
                      className = 'btn no_pd ml5 gree-Bgr'
                      clearable = {false}
                />
                <label className='titleHead ml5'> Page Limit: </label>
                {/* <Select
                      name="limit"
                      value={limit}
                      options={limitOptions}
                      onChange={this.setNewLimit}
                      removeSelected={false}
                      className = 'btn no_pd ml5 gree-Bgr'
                      clearable = {false}
                /> */}
                <label className='titleHead ml5'> Actions: </label>
                <button className='ml5 btn-Head gree-Bgr' onClick = {()=>{this.loadJobs()}}>
                  <span className="glyphicon glyphicon-repeat" aria-hidden="true"></span> Reload Data
                </button>
              </div>
            </div>
        </div>
          <DataGrid headers={this.headers} rows={rows}/>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/JobsDashboard.jsx